import classNames from "classnames";
import { Button } from "PFComponents/button";
import ButtonGroup from "PFComponents/button_group/button_group";
import DataTable from "PFComponents/data_table/data_table";
import i18n from "PFCore/i18n";
import PropTypes from "prop-types";
import React from "react";

import css from "./permissions_group_edit_page.module.scss";

export default class PermissionsGroupATEdit extends React.Component {
  componentDidMount() {
    this.sanitizeValues();
  }

  levelToCopy = (level) => ({ ro: i18n.t("permissions.read"), rw: i18n.t("permissions.readWrite") }[level]);

  setAll = (level) => {
    const { activityTypes, handleChange } = this.props;

    activityTypes.forEach((at) => {
      const newLevel = this.isRWOnly(at) ? "rw" : level;
      handleChange(at.id, newLevel);
    });
  };

  sanitizeValues() {
    const { activityTypes, handleChange, atIdToPermLevel } = this.props;

    activityTypes.forEach((at) => {
      const level = atIdToPermLevel[at.id] || "hidden";
      const newLevel = this.isRWOnly(at) ? "rw" : level;
      handleChange(at.id, newLevel);
    });
  }

  isRWOnly = (at) => {
    const { isCurrentPG } = this.props;
    const isMandatory = !!at.mandatory;

    return isCurrentPG && isMandatory;
  };

  render() {
    const activityTypes = this.props.activityTypes.filter(({ mandatory }) => mandatory === false);

    return (
      <React.Fragment>
        <div style={{ textAlign: "right", marginBottom: 5 }}>
          <ButtonGroup autoWidth className={classNames(css.buttonGroup, css.header)}>
            <Button small kind="tertiary" onClick={() => this.setAll("hidden")}>
              {i18n.t("permissions.allHidden")}
            </Button>
            <Button small kind="tertiary" onClick={() => this.setAll("ro")}>
              {i18n.t("permissions.allRead")}
            </Button>
            <Button small kind="tertiary" onClick={() => this.setAll("rw")}>
              {i18n.t("permissions.allReadWrite")}
            </Button>
          </ButtonGroup>
        </div>

        <DataTable
          qaId={`PermissionsGroupATEdit`}
          data={activityTypes}
          columns={[
            {
              renderCell: (at) => (
                <span>
                  {at.name} <small style={{ opacity: 0.4 }}>({at.name})</small>
                </span>
              )
            },
            {
              narrow: true,
              renderCell: (at) => (
                <ButtonGroup autoWidth className={css.buttonGroup}>
                  {this.renderButton(at, "hidden")}
                  {this.renderButton(at, "ro")}
                  {this.renderButton(at, "rw")}
                </ButtonGroup>
              )
            }
          ]}
        />
      </React.Fragment>
    );
  }

  renderButton(at, level) {
    const { handleChange, atIdToPermLevel } = this.props;

    const disabled = this.isRWOnly(at) && (level === "hidden" || level === "ro");

    return (
      <Button
        small
        kind={level === (atIdToPermLevel[at.id] || "hidden") ? "secondary" : "primary"}
        onClick={() => handleChange(at.id, level)}
        disabled={disabled}
      >
        {this.levelToCopy(level) || i18n.t("permissions.hidden")}
      </Button>
    );
  }
}

PermissionsGroupATEdit.propTypes = {
  /** ActivityTypes */
  activityTypes: PropTypes.any.isRequired,
  /** { [id1]: "ro", [id2]: "rw", ... } */
  atIdToPermLevel: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  isCurrentPG: PropTypes.bool.isRequired
};
